<div class="checkout-car-list">
  <div class="loading" *ngIf="loading">
    <div class="sk-wandering-cubes">
      <div class="sk-cube bg-primary sk-cube-1"></div>
      <div class="sk-cube bg-primary sk-cube-2"></div>
    </div>
  </div>
  <div *ngIf="!isMultiDimension" cdkDropList (cdkDropListDropped)="drop($event)">
    @if (mappedData && showDates) {
      <div class="d-flex delivery-global-date justify-content-end mb-3 align-items-center">
        <span translate class="mr-2">EST_DISPATCH_DATE</span>
        <lib-delivery-date-picker
          class="request-delivery-date"
          label=""
          [useSameDayInicialDate]="true"
          [minInitialDate]="minPossibleDate"
          [currentselectedDate]="deliveryDate"
          (selectedDate)="dateSelected($event)"
        ></lib-delivery-date-picker>
      </div>
    }

    @if (isCustomerService && mappedData && showDates) {
      <div class="d-flex delivery-global-date justify-content-end mb-3 align-items-center">
        <span class="mr-2">{{ 'CUSTOMER_REQ_DISPATCH_DATE' | translate }}</span>
        <i [ngbTooltip]="'CUSTOMER_REQ_DISPATCH_DATE_INFO' | translate" class="fa-solid fa-info-circle mr-2"></i>
        <lib-delivery-date-picker
          class="request-delivery-date"
          label=""
          [useSameDayInicialDate]="true"
          [minInitialDate]="today"
          [currentselectedDate]="customerRequestedDate"
          (selectedDate)="customerRequestedDateSelected($event)"
        ></lib-delivery-date-picker>
      </div>
    }

    <div class="row">
      <div class="col-1 col-lg-2"></div>
      <div class="col-11 col-lg-10">
        <div class="row">
          <div
            class="col-3"
            [ngClass]="{ 'col-md-5': hidePrices || !isCustomerService, 'col-md-3': !hidePrices && isCustomerService }"
          ></div>
          <div
            class="col-2 text-center d-none d-md-block"
            [ngClass]="{ 'col-md-3': hidePrices || !isCustomerService, 'col-md-2': !hidePrices || isCustomerService }"
          >
            <span *ngIf="!hideAvailabilities" translate>AVAILABILITY</span>
          </div>
          <div class="col-1 text-center d-none d-md-block">
            @if (showDates) {
              <span class="d-block mb-3" translate>EST_DISPATCH_DATE</span>
            }
          </div>
          @if (isCustomerService) {
            <div class="col-2 text-center d-none d-md-block">
              <span translate>TEXT_BETWEEN_ORDER_ROWS</span>
              <i [ngbTooltip]="'TEXT_BETWEEN_ORDER_ROWS_INFO' | translate" class="fa-solid fa-info-circle pl-2"></i>
            </div>

            <div class="col-1 text-center d-none d-md-block">
              <span translate>EXTERNAL_TEXT</span>
            </div>
          }
          @if (!hidePrices) {
            <div class="col-2 text-center d-none d-md-block">
              <span translate>PRICE</span>
            </div>
            <div class="col-1 text-right d-none d-md-block">
              <span translate>TOTAL</span>
            </div>
          }
        </div>
      </div>

      <div class="col-12">
        <div class="border-bottom"></div>
      </div>
    </div>
    @for (
      mappedDataRow of !sortByOptions ? mappedData : (mappedData | orderBy: 'asc' : sortByFn);
      track mappedDataRow.product.id + mappedDataRow.cartRow.productPartialId;
      let i = $index
    ) {
      <div class="row" cdkDrag [ngClass]="{ 'skip-broken-box-fee': shouldApplyBrokenBoxFee(mappedDataRow) }">
        <div class="col example-custom-placeholder" *cdkDragPlaceholder></div>
        <div class="col-1 col-lg-2 d-flex actions-row mt-1">
          <button type="button" class="btn btn-link" style="cursor: move" cdkDragHandle>
            <i class="fa-solid fa-arrow-right-arrow-left" style="transform: rotate(90deg)"></i>
          </button>
          <button type="button" class="btn btn-light rounded-circle btn-m-l" (click)="removeRow(mappedDataRow.cartRow)">
            <i class="fa-solid fa-xmark"></i>
          </button>
          <button type="button" class="btn btn-light rounded-circle btn-m-l" (click)="openCommentsModal(mappedDataRow)">
            <i class="far fa-file-alt"></i>
          </button>
        </div>
        <div class="col-11 col-lg-10">
          <div class="row">
            <div class="col-3 col-md-1">
              <div
                class="navigate-to-product-details cart-col product-image"
                [routerLink]="['/product/', mappedDataRow.product.id]"
              >
                <img
                  class="img-fluid my-3"
                  style="max-width: 64px"
                  *ngIf="mappedDataRow.product.extra.images && mappedDataRow.product.extra.images.length > 0"
                  [src]="
                    mappedDataRow.product.extra.images[0].s3Uri
                      | gungImageUrl: 'type:thumbnail' : 'etag:' + mappedDataRow.product.extra.images[0].s3ETag
                  "
                  alt=""
                />
              </div>
            </div>
            <div
              class="col-8 d-flex align-items-center pmobile-b pb-2"
              [ngClass]="{ 'col-md-4': hidePrices || !isCustomerService, 'col-md-2': !hidePrices && isCustomerService }"
            >
              <div class="w-100">
                <div
                  class="navigate-to-product-details cart-col"
                  [routerLink]="['/product/', mappedDataRow.product.id]"
                >
                  <div class="mb-3">
                    <b>{{ mappedDataRow.product.id }}</b> - {{ mappedDataRow.product.name }}
                    @if (isSales) {
                      <div class="product-text">{{ getDescription(mappedDataRow) }}</div>
                    }
                    @if (isCustomerService) {
                      {{ mappedDataRow.product.extra?.ar?.q_hl_ext_item_number }}
                    }
                  </div>
                </div>
                @if (addInstallationCharge && installationChargeProductId === mappedDataRow.product.id && !isSales) {
                  <span>{{ 'QUANTITY' | translate }}: </span>{{ mappedDataRow.cartRow.qty }}
                } @else {
                  <app-hl-display-buy-btn
                    [product]="mappedDataRow.product"
                    [id]="mappedDataRow.product.id"
                    [productPartialId]="mappedDataRow.cartRow.productPartialId"
                    [price]="mappedDataRow.price"
                    class="d-block"
                    style="max-width: 125px"
                  ></app-hl-display-buy-btn>
                }
              </div>
            </div>
            <div
              class="col-12 d-flex align-items-center pmobile-b justify-content-md-center pb-2"
              [ngClass]="{ 'col-md-3': hidePrices || !isCustomerService, 'col-md-2': !hidePrices || isCustomerService }"
            >
              <div *ngIf="!hideAvailabilities" class="col-auto d-block d-sm-block d-md-none">
                <span translate>AVAILABILITY</span>:&nbsp;
              </div>
              <app-hl-display-availability *ngIf="!hideAvailabilities" [availability]="mappedDataRow.availability" />
            </div>
            <div class="col-12 col-md-1 d-flex align-items-md-center pmobile-b justify-content-md-center pb-2">
              <div class="col-auto d-block d-sm-block d-md-none"><span translate>EST_DISPATCH_DATE</span>:&nbsp;</div>
              @if (showDates) {
                {{ mappedDataRow.deliveryDate }}
              }
            </div>

            @if (isCustomerService) {
              <div class="col-12 col-md-2 d-flex align-items-center pmobile-b justify-content-md-center pb-2">
                <div class="col-auto d-block d-sm-block d-md-none">
                  <span translate>TEXT_BETWEEN_ORDER_ROWS</span>:&nbsp;
                </div>
                <div>
                  <input
                    type="text"
                    class="form-control"
                    [ngModel]="mappedDataRow.cartRow?.extra?.orp?.q_hl_txtbtwnrows"
                    (change)="setCartRowExtra(mappedDataRow.cartRow, $event, 'orp.q_hl_txtbtwnrows')"
                    (blur)="setCartRowExtra(mappedDataRow.cartRow, $event, 'orp.q_hl_txtbtwnrows')"
                    (click)="$event.preventDefault(); $event.stopPropagation()"
                  />
                </div>
              </div>

              <div class="col-12 col-md-1 d-flex align-items-center pmobile-b justify-content-md-center pb-2">
                <div class="col-auto d-block d-sm-block d-md-none"><span translate>EXTERNAL_TEXT</span>:&nbsp;</div>
                <div>
                  <input
                    type="text"
                    class="form-control"
                    [ngModel]="mappedDataRow.cartRow?.extra?.orp?.editext"
                    (change)="setCartRowExtra(mappedDataRow.cartRow, $event, 'orp.editext')"
                    (click)="$event.preventDefault(); $event.stopPropagation()"
                  />
                </div>
              </div>
            }

            @if (!hidePrices) {
              <div class="col-12 col-md-2 d-flex align-items-center pmobile-b justify-content-md-center pb-2">
                <div class="col-auto d-block d-sm-block d-md-none"><span translate>PRICE</span>:&nbsp;</div>
                <div *ngIf="isSales; else showOnlyPrice">
                  <input
                    type="number"
                    class="form-control"
                    [class.small-number-input]="!currentFlow.requireAvailability && !currentFlow.useAvailabilities"
                    [ngModel]="mappedDataRow.price.cartRowUnitPrice.value"
                    (change)="setPrice($event, mappedDataRow.cartRow)"
                    (click)="$event.preventDefault(); $event.stopPropagation()"
                  />
                </div>
                <ng-template #showOnlyPrice>
                  <lib-price [price]="mappedDataRow.price" type="cartRowUnitPrice"></lib-price>
                  <span *ngIf="mappedDataRow.price.cartRowDiscountPercent !== 0">
                    (-{{ mappedDataRow.price.cartRowDiscountPercent }}%)
                  </span>
                </ng-template>
              </div>
              <div class="col-12 col-md-1 d-flex align-items-center pmobile-b justify-content-md-end pb-2">
                <div class="col-auto d-block d-sm-block d-md-none"><span translate>TOTAL</span>:&nbsp;</div>
                <lib-price [price]="mappedDataRow.price" type="cartRowTotalPriceInclRowDiscount"></lib-price>
              </div>
            }
          </div>
        </div>
        <div class="col-12">
          <div class="border-bottom"></div>
        </div>
      </div>
    } @empty {
      <div class="w-100 text-center">There are no items.</div>
    }
  </div>
  <div class="d-flex pt-3" *ngIf="isSales || isProjectManager">
    <button
      *ngIf="isSales || isProjectManager"
      class="btn btn-primary btn-circle"
      type="button"
      (click)="addNewOrderLine()"
    >
      <i class="fas fa-plus"></i>
    </button>

    @if (shouldAddInstallationChargeManually) {
      <button class="btn btn-primary btn-circle ms-2" type="button" (click)="addInstallationChargeFixed(0.15)">
        15%
      </button>
      <button class="btn btn-primary btn-circle mx-2" type="button" (click)="addInstallationChargeFixed(0.1)">
        10%
      </button>
      <button class="btn btn-primary btn-circle" type="button" (click)="addInstallationChargeFixed(0.08)">8%</button>
    }
    @if (isCustomerService) {
      <div class="ml-auto text-start" style="max-width: 150px">
        <div class="d-flex align-items-center mb-2">
          <input
            type="checkbox"
            id="inlineCheckbox4"
            class="form-check-input mr-2"
            [ngModel]="checkout.extra._ignoreAllBrokenBoxFees"
            (ngModelChange)="ignoreAllBrokenBoxFeeChanged()"
          />
          <label class="form-check-label" for="inlineCheckbox4">
            {{ 'IGNORE_ALL_BROKEN_BOX_FEES' | translate }}
          </label>
        </div>

        <div class="d-flex align-items-center mb-2">
          <input
            type="checkbox"
            id="inlineCheckbox3"
            class="form-check-input mr-2"
            [checked]="!checkout.extra._skipAdminFee"
            (change)="emitSkipAdminFee()"
          />
          <label class="form-check-label" for="inlineCheckbox3">
            {{ 'CHARGE_SMALL_ORDER_FEE' | translate }}
          </label>
        </div>
      </div>
    }
  </div>
</div>
